import React from 'react'
import { Trans } from '@lingui/macro'
import classNames from 'classnames'
import { css } from '@emotion/react'
import { useLooopTheme } from '../../../public-api/hooks/useLooopTheme'

import IconClose from '../icon/IconClose'
import { brandColors } from '../../../../../shared/basicPalette'
import { isColorDark } from 'shared/colorUtils'
import { LinkBox } from 'front-end/src/components'
import { LinkBoxProps } from '@chakra-ui/react'

import './Tag.less'

export type TagColorsEnum =
  | 'grey'
  | 'greyLight'
  | 'green'
  | 'red'
  | 'clear'
  | 'clearDarker'
  | 'redOpen'
  | 'greenLight'
  | 'yellow'
  | 'orange'
  | 'white'
  | 'blue'
  | 'primary'
  | 'chip'
  | 'chipError'

interface TagBasicProps {
  children?: any
  textValue?: string
  size?: 'small' | 'normal' | 'large'
  color?: TagColorsEnum
  className?: string
  onClick?: (ev: React.MouseEvent<HTMLDivElement>) => void
  onClickClose?: (
    ev: React.MouseEvent<HTMLSpanElement>,
    textValue?: string
  ) => void
  closeIcon?: any
}
export type ITagProps = TagBasicProps & LinkBoxProps

export const Tag: React.FC<ITagProps> = (props) => {
  const { theme } = useLooopTheme()
  const {
    children,
    size,
    color,
    className,
    onClickClose,
    textValue,
    closeIcon,
    ...rest
  } = props
  const showClose = !!onClickClose
  const clickable = !!props.onClick
  const CloseIcon = closeIcon || IconClose

  return (
    <LinkBox
      className={classNames(
        'Tag',
        className,
        size ?? 'normal',
        `Tag--${color ?? 'grey'}`,
        { clickable }
      )}
      data-test="Tag"
      tabIndex={clickable ? 0 : -1}
      css={
        color === 'primary' &&
        css`
          background-color: ${theme.colors.buttonPrimary.default};
          color: ${isColorDark(theme.colors.buttonPrimary.default)
            ? brandColors.white
            : brandColors.grey.dark};
        `
      }
      {...rest}
    >
      {children}
      {showClose && (
        <CloseIcon
          className="Tag--close"
          onClick={(e: React.MouseEvent<HTMLSpanElement>) => {
            e.stopPropagation()
            onClickClose && onClickClose(e, textValue)
          }}
        />
      )}
    </LinkBox>
  )
}

export const TagBeta = (props: ITagProps) => {
  return (
    <Tag size="small" color="orange" className="TagBeta" ml="4px" {...props}>
      <Trans>BETA</Trans>
    </Tag>
  )
}

export const TagNew = (props: ITagProps) => {
  return (
    <Tag size="small" color="orange" ml="4px" {...props}>
      <Trans>NEW</Trans>
    </Tag>
  )
}

export default Tag
